import { useContent } from '@/content';
import { Editable, Sortable } from '@/content/design';

const icons = ['ri-heart-fill', 'ri-sparkling-fill', 'ri-shield-check-fill'];

export default function PhilosophySection() {
  const c = useContent();
  return (
    <section className="py-20 md:py-28 bg-blush-50/50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14 animate-on-scroll">
          <Editable as="p" id="philosophy.eyebrow" label="Philosophie – Kleine Überschrift" className="text-xs tracking-[0.3em] uppercase text-champagne-500 font-medium mb-3">
            {c.philosophy.eyebrow}
          </Editable>
          <Editable as="h2" id="philosophy.title" label="Philosophie – Titel" className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-6">
            {c.philosophy.title}
          </Editable>
          <div className="max-w-3xl mx-auto">
            <Editable as="p" id="philosophy.intro1" label="Philosophie – Absatz 1" className="text-gray-600 leading-relaxed text-sm md:text-base">
              {c.philosophy.intro1}
            </Editable>
            <Editable as="p" id="philosophy.intro2" label="Philosophie – Absatz 2" className="text-gray-600 leading-relaxed text-sm md:text-base mt-4">
              {c.philosophy.intro2}
            </Editable>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {c.philosophy.cards.map((item, index) => (
            <Sortable
              key={index}
              path={['philosophy', 'cards']}
              index={index}
              className={`animate-on-scroll delay-${(index + 1) * 150} bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-blush-100 hover:shadow-md hover:-translate-y-1 transition-all duration-300`}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne-50 mb-5">
                <i className={`${icons[index] ?? icons[0]} text-champagne-500 text-xl`}></i>
              </div>
              <Editable as="h3" id={`philosophy.cards.${index}.title`} label="Karte – Titel" className="font-display text-xl text-gray-800 mb-3">
                {item.title}
              </Editable>
              <Editable as="p" id={`philosophy.cards.${index}.desc`} label="Karte – Text" className="text-sm text-gray-500 leading-relaxed">
                {item.desc}
              </Editable>
            </Sortable>
          ))}
        </div>
      </div>
    </section>
  );
}